import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { StudyReportReverseReason } from "../../../model/study-report-reverse-reason";
import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { NotificationToastService } from "../../../services/notification-toast.service";
import { StudyReportReverse } from "../../../model/study-rerport-reverse";
import { StudyReportService } from "../../../services/study-report/study-report.service";
import { LogisticsService } from "src/app/services/logistics.service";
import { SectorService } from "src/app/services/sector/sector.service";
import { FilterService } from "src/app/services/filter.service";
import { SectorFilter } from "src/app/model/sector-filter";
import { AuthService } from "src/app/services/auth.service";
import { StudyReportSearchItem } from "src/app/model/study-report-search-item";

@Component({
  selector: "study-report-delivery-sector-dialog",
  templateUrl: "study-report-delivery-sector-dialog.component.html",
  styleUrls: ["./study-report-delivery-sector-dialog.component.css"],
})
export class StudyReportDeliverySectorDialogComponent implements OnInit {
  form: FormGroup;
  sectors: SectorFilter[] = [];
  allSectors: SectorFilter[] = [];
  loading: boolean;
  sending: boolean;

  constructor(
    public dialogRef: MatDialogRef<StudyReportDeliverySectorDialogComponent>,
    private filterService: FilterService,
    private logisticsService: LogisticsService,
    private authService: AuthService,
    private formBuilder: FormBuilder,
    private notificationToastService: NotificationToastService,
    @Inject(MAT_DIALOG_DATA) public data: StudyReportSearchItem[]
  ) {
    this.form = this.formBuilder.group({
      sector: [null, Validators.required],
      StudyReportSearchItems: [this.data],
    });
  }

  get f() {
    return this.form.controls;
  }

  onNoClick(): void {
    this.dialogRef.close(false);
  }

  async save() {
    try {
      if (this.form.valid) {
        this.sending = true;
        const sourceSectorId = this.authService.getSectorId();
        const sourceSector = this.allSectors.find((x) => x.Id === sourceSectorId);
        await this.logisticsService.studyReportBatchIndividualSendFromStudyControl(
          sourceSector,
          this.form.value.sector,
          this.data
        );

        this.dialogRef.close(false);
      }
    } catch (err) {
      this.notificationToastService.error(
        JSON.stringify(err.error),
        "Envio de informes"
      );
    } finally {
      this.sending = false;
    }
  }

  async ngOnInit() {
    try {
      this.loading = true;
      this.allSectors = await this.filterService.getSectorsFilter();
      this.sectors = this.allSectors.filter((x) => x.IsDelivery);
    } catch (err) {
      this.notificationToastService.error(
        JSON.stringify(err.error),
        "Envio de informes"
      );
    } finally {
      this.loading = false;
    }
  }
}
